/* eslint-disable */
export default {
  log: '기록',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
